import firebase from 'firebase';
import { roles } from './AuthService';
import { userActionTypes } from './Reducers/userReducer';

const paginationSize = 50;

export const userRoleReadable = (role) => {
  switch (role) {
    case roles.ADMIN:
      return 'Administrator';
    case roles.BASIC:
      return 'Basic User';
    default:
      return 'User';
  }
};

export const getAllUsers = async (users, userDispatch) => {
  const firestore = firebase.firestore();
  const userCollection = firestore.collection('users');
  let userDocs;
  if (users.length > 0) {
    const lastUser = users[users.length - 1];
    userDocs = await userCollection.where('created', '<', lastUser.created).orderBy('created', 'desc').limit(paginationSize).get();
  } else {
    userDocs = await userCollection.orderBy('created', 'desc').limit(paginationSize).get();
  }

  if (userDocs.docs.length > 0) {
    console.log(userDocs.docs.length);
    userDispatch({
      type: userActionTypes.SET_USER_LIST,
      userList: [...users, ...userDocs.docs.map(userDoc => userDoc.data())],
    });
  }
};

export const getFilteredUsers = async (keyword, userDispatch) => {
  const firestore = firebase.firestore();
  const userCollection = firestore.collection('users');
  let userDocs = await userCollection.where('keywords', 'array-contains-any', keyword.toLowerCase().split(' ')).get();
  userDispatch({
    type: userActionTypes.SET_USER_LIST,
    userList: userDocs.docs.map(userDoc => userDoc.data()),
  });
};

export const getAdmins = async (userDispatch) => {
  const firestore = firebase.firestore();
  const userCollection = firestore.collection('users');
  let userDocs = await userCollection.where('role', '==', roles.ADMIN).get();
  userDispatch({
    type: userActionTypes.SET_USER_LIST,
    userList: userDocs.docs.map(userDoc => userDoc.data()),
  });
};

export const updateUserRole = async (userId, role, userState, userDispatch) => {
  try {
    const addRole = firebase.functions().httpsCallable('addRole');
    await addRole({
      uid: userId,
      role: role,
    }).then((res) => console.log(res));
    await firebase.firestore().collection('users').doc(userId).update({ role: role });
    userDispatch({
      type: userActionTypes.SET_USER_LIST,
      userList: userState.userList.map(e => e.uid === userId ? { ...e, role: role } : e),
    });
  } catch (err) {
    console.log(err);
  }
};


export const generateKeyWords = (name) => {
  const keywords = [];
  var strArr = name.split(' ');
  for (let i = 0; i < strArr.length; i++) {
    const word = strArr[i];
    for (let j = 0; j < word.length; j++) {
      for (let k = j + 1; k <= word.length; k++) {
        keywords.push(word.substring(j, k).toLowerCase());
      }
    }
  }
  return [...new Set(keywords)];
};
